// @venders
const moment = require('moment');

// @utilities
const { formatText } = require('core/i18n').i18n;

const {
    RA_PORTFOLIO_WITH_RISK_LEVEL_1,
    RA_PORTFOLIO_WITH_RISK_LEVEL_2,
    RA_PORTFOLIO_WITH_RISK_LEVEL_3,
    RA_PORTFOLIO_WITH_RISK_LEVEL_4,
    RA_PORTFOLIO_WITH_RISK_LEVEL_5,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../raConstants/index');

const petronas = require('../assets/icons/buildings/Buildings_Petronas.svg');
const shangai = require('../assets/icons/buildings/Buildings_Shanghai.svg');
const taipei = require('../assets/icons/buildings/Buldings&Skyline_Taipei.svg');
const wtc = require('../assets/icons/buildings/Buildings_WTC.svg');
const khalifa = require('../assets/icons/buildings/Buildings_Khalifa.svg');

const petronasLine = require('../assets/icons/buildings/Buildings_Petronas_iconline.svg');
const shangaiLine = require('../assets/icons/buildings/Buildings_Shangai_iconline.svg');
const taipeiLine = require('../assets/icons/buildings/Buildings_Taipei_iconline.svg');
const wtcLine = require('../assets/icons/buildings/Buildings_WTC_iconline.svg');
const khalifaLine = require('../assets/icons/buildings/Buildings_Khalifa_iconline.svg');
const portfolioError = require('../assets/icons/buildings/Portfolio_API_Error_Icon.svg');

const petronasCircle = require('../assets/icons/buildings/KualaLumpur_circle.svg');
const shangaiCircle = require('../assets/icons/buildings/Shanghai_circle.svg');
const taipeiCircle = require('../assets/icons/buildings/Taipei_circle.svg');
const wtcCircle = require('../assets/icons/buildings/NewYork_circle.svg');
const khalifaCircle = require('../assets/icons/buildings/Dubai_circle.svg');

const Portfolios = {
    '1': {
        portfolioId: 1,
        portfolioName: RA_PORTFOLIO_WITH_RISK_LEVEL_1,
        icon: petronas,
        iconLine: petronasLine,
        iconCircle: petronasCircle,
    },
    '2': {
        portfolioId: 2,
        portfolioName: RA_PORTFOLIO_WITH_RISK_LEVEL_2,
        icon: shangai,
        iconLine: shangaiLine,
        iconCircle: shangaiCircle,
    },
    '3': {
        portfolioId: 3,
        portfolioName: RA_PORTFOLIO_WITH_RISK_LEVEL_3,
        icon: taipei,
        iconLine: taipeiLine,
        iconCircle: taipeiCircle,
    },
    '4': {
        portfolioId: 4,
        portfolioName: RA_PORTFOLIO_WITH_RISK_LEVEL_4,
        icon: wtc,
        iconLine: wtcLine,
        iconCircle: wtcCircle,
    },
    '5': {
        portfolioId: 5,
        portfolioName: RA_PORTFOLIO_WITH_RISK_LEVEL_5,
        icon: khalifa,
        iconLine: khalifaLine,
        iconCircle: khalifaCircle,
    },
    '6': {
        portfolioId: 6,
        portfolioName: formatText(
            'raSummaryWidget-portfolioSaveSimulationError',
        ),
        icon: portfolioError,
        iconLine: khalifaLine,
    },
};

const filterByGoals = portfolio =>
    portfolio.filter(portfolio => portfolio.get('hasGoal'));

const filterPurePortfolios = portfolio =>
    portfolio.filter(portfolio => !portfolio.get('hasGoal'));

const getPeriodicity = (recurringCode, contributionDay) => {
    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            return [
                {
                    dia: 1,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 2,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 3,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 4,
                    mes: 0,
                    tiempo: 1,
                },
                {
                    dia: 5,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        case CONTRIBUTION_PERIOD_WEEKLY:
            const day = moment().day();
            return [
                {
                    dia: day === 0 || day === 6 ? 1 : day,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        case CONTRIBUTION_PERIOD_MONTHLY:
            return [
                {
                    dia: contributionDay,
                    mes: 0,
                    tiempo: 1,
                },
            ];
        default:
            return [];
    }
};

module.exports = {
    Portfolios,
    filterByGoals,
    filterPurePortfolios,
    getPeriodicity,
};
